import { render, staticRenderFns } from "./AppTabDeletor.vue?vue&type=template&id=76bde156&scoped=true&"
import script from "./AppTabDeletor.vue?vue&type=script&lang=ts&"
export * from "./AppTabDeletor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bde156",
  null
  
)

export default component.exports